module.exports = __webpack_public_path__ + "static/img/faPath2.b998977c.gif";